import React from "react";

export default function PopupModal({ show, onClose, type, title, message }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Fondo oscuro semitransparente */}
      <div
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Caja modal */}
      <div className="relative bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white rounded-2xl shadow-2xl w-[350px] p-6 text-center border border-gray-700 animate-fadeIn">
        {/* Emoji ❌ o ✅ grande */}
        <div className="text-5xl mb-4">
          {type === "error" ? "❌" : "✅"}
        </div>

        <h2 className="text-lg font-bold mb-2">{title}</h2>
        <p className="text-gray-300 mb-6">{message}</p>

        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 text-white transition"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}
